import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { Col, Row } from 'react-bootstrap';
import Loader from '../Loader/Loader';
import { postContact } from '../../apiservices/ApiServices';
import SelectFild from '../SelectFild/SelectFild';
import AutoCompleteMobile from '../AutoCompleteMobile/AutoCompleteMobile';
import { postOrgContactPersonSearch } from '../../apiservices/ApiServices';

const ContactPerson = (props) => {
    const [isLoadings, setLoadings] = useState(false);
    const [designationOptions, srtDesignationOptions] = useState([]);
    const [mobilSearchList, setMobilSearchList] = useState([]);

    const initialValues = {
        orgId: props.orgId || '',
        mobile: props.editContact?.mobile_number || '',
        id: props.editContact?.contact_person_id || '',
        mid: props.editContact?.user_id || '',
        firstName: props.editContact?.first_name || '',
        lastName: props.editContact?.last_name || '',
        email: props.editContact?.email || '',
        function: props.editContact?.function?.id || '',
        designation: props.editContact?.designation?.id || '',
        isUserProfile: props?.editContact?.is_user_profile ? 1 : 0,
        orgTypeCode: props?.orgTypeCode,
    }

    const { values, errors, touched, handleBlur, setFieldValue, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            let postData = {
                org_id: values.orgId,
                contact_person_id: values.id,
                user_id: values.mid,
                first_name: values.firstName,
                last_name: values.lastName,
                email: values.email,
                mobile_number: values.mobile,
                function_id: values.function,
                designation_id: values.designation,

                is_user_profile: values.isUserProfile,
                org_type_code: values.orgTypeCode,

            }
            try {
                const res = await postContact(postData);
                props.toast.success(res.data.message);
                props.setAddContactPerson(false)
                setLoadings(false);
                props.postUpdateOrganizationProfiles();

            } catch (error) {
                setLoadings(false);
                props.toast.error(error.response?.data?.message || "Error submitting data");
            }

        }
    })

    useEffect(() => {
        if (values.function) {
            const selectedFunction = props?.functionList.find(functions => functions.id == values.function);

            if (selectedFunction && selectedFunction.designations && selectedFunction.designations.length > 0) {
                //console.log(selectedFunction.designations)
                srtDesignationOptions(selectedFunction.designations);
                setFieldValue('designation', props.editContact?.designation?.id || '')
            } else {
                srtDesignationOptions([]);
            }
        } else {
            srtDesignationOptions([]);
        }
    }, [values.function]);

    const postOrgContactPersonSearchs = async (postData) => {
        setLoadings(true);
        try {
            const res = await postOrgContactPersonSearch(postData);
            setMobilSearchList(res.data.data);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            props.toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        if (values?.mobile && values.mobile.length == 5) {
            const postData = {
                search_text: values.mobile
            };
            postOrgContactPersonSearchs(postData);
        }
    }, [values.mobile]);


    return (
        <>
            <div className='fieldsets cols_5'>
                <div className='fieldsets-title'>Add Contact Person</div>
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <AutoCompleteMobile
                                    name="mobile"
                                    label="Mobile Number"
                                    suggestions={mobilSearchList || []}
                                    placeholder="Type to search Mobile Number..."
                                    value={values.mobile}
                                    displayField="mobile_number"
                                    valueField="user_id"
                                    onChange={(fieldName, value) => {
                                        if (typeof value === 'object') {
                                            setFieldValue('mid', value.user_id);
                                            setFieldValue('mobile', value.mobile_number);
                                            setFieldValue('firstName', value.first_name);
                                            setFieldValue('lastName', value.last_name);
                                            setFieldValue('email', value.email);
                                        } else {
                                            setFieldValue('mid', '');
                                            setFieldValue('mobile', '');
                                            setFieldValue('firstName', '');
                                            setFieldValue('lastName', '');
                                            setFieldValue('email', '');
                                            setFieldValue(fieldName, value);
                                        }
                                    }}
                                    onBlur={handleBlur}
                                    error={errors.mobile}
                                    touched={touched.mobile}
                                />
                                {errors.mobile && touched.mobile && (
                                    <p className="errormsg">{errors.mobile}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">First Name</label>
                                <input
                                    type='text'
                                    id="firstName"
                                    name="firstName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.firstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.firstName && touched.firstName && (
                                    <p className="errormsg">{errors.firstName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Last Name</label>
                                <input
                                    type='text'
                                    id="lastName"
                                    name="lastName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.lastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.lastName && touched.lastName && (
                                    <p className="errormsg">{errors.lastName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Email</label>
                                <input
                                    type='text'
                                    id="email"
                                    name="email"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.email && touched.email && (
                                    <p className="errormsg">{errors.email}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Function</label>
                                <SelectFild
                                    Firstop='Select Function'
                                    selectName="function"
                                    options={props?.functionList}
                                    value={values.function}
                                    onChange={(selectedOption) => setFieldValue("function", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.function && touched.function && (
                                    <p className="errormsg">{errors.function}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Designation</label>
                                <SelectFild
                                    Firstop='Select Designation'
                                    selectName="designation"
                                    options={designationOptions}
                                    value={values.designation}
                                    onChange={(selectedOption) => setFieldValue("designation", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.function && touched.function && (
                                    <p className="errormsg">{errors.function}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                    <label className="form-label">has User Profile</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            id='isUserProfile'
                                            name='isUserProfile'
                                            className="form-control"
                                            autoComplete='off'
                                            checked={values.isUserProfile === 1}
                                            onChange={(e) => {
                                                setFieldValue(
                                                    'isUserProfile',
                                                    e.target.checked ? 1 : 0
                                                );
                                            }}
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{props.editContact?.contact_person_id ? 'Update' : 'Save'}</button>
                            <button type='button' onClick={() => { props.setAddContactPerson(false); props.setEditContact(null); }} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default ContactPerson
